/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Materials_MinInputs */

const vi_care_log_materials_min = /** @type {(inputs: Care_Log_Materials_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bón phân / Phun thuốc phải chọn ít nhất 1 vật tư nông nghiệp`)
};

/**

* @param {Care_Log_Materials_MinInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_materials_min = /** @type {((inputs?: Care_Log_Materials_MinInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Materials_MinInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_materials_min(inputs)
});